import { Link } from 'react-router-dom';
import { Button } from '@components/ui/button';

interface ErrorPageProps {
  error?: Error | null;
}

export default function ErrorPage({ error }: ErrorPageProps) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="text-6xl font-bold text-muted-foreground">Error</h1>
      <p className="mt-4 text-lg text-muted-foreground">
        Something went wrong. Please try again later.
      </p>
      {error?.message && (
        <p className="mt-2 max-w-md text-sm text-muted-foreground/70">
          {error.message}
        </p>
      )}
      <Link to="/home" className="mt-6">
        <Button>Return to home</Button>
      </Link>
    </div>
  );
}
